/**
 * Checks whether the provided data is a binary type (Blob, ArrayBuffer, or File).
 * @param {*} data - The data to check.
 * @returns {boolean} - True if data is binary, false otherwise.
 */
function isBinary(data) {
  return data instanceof Blob || data instanceof ArrayBuffer || data instanceof File;
}

module.exports = isBinary;
